var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "7px",
    height: "7px",
    viewBox: "-0.45 -0.45 7 7",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.674.611H2.607c-.254 0-.46.206-.46.46v.461h-.423c-.122 0-.239.049-.325.135l-.958.958c-.086.087-.134.204-.134.326v1.037H.23c-.127 0-.23.103-.23.23v.154c0 .127.103.23.23.23h.383c0 .51.412.921.92.921.509 0 .92-.412.92-.92h1.228c0 .508.412.92.92.92s.92-.412.92-.92h.383c.128 0 .23-.104.23-.23V1.071c0-.255-.205-.46-.46-.46zm-4.14 4.452c-.254 0-.46-.207-.46-.46 0-.255.206-.461.46-.461.253 0 .46.206.46.46s-.207.46-.46.46zm.613-1.996H.767v-.116l.957-.958h.423v1.074zm2.454 1.996c-.254 0-.46-.207-.46-.46 0-.255.206-.461.46-.461s.46.206.46.46-.206.46-.46.46z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruck);
export default __webpack_public_path__ + "static/media/truck.c3f94be31227d330f816dcc55b83ae8d.svg";
export { ForwardRef as ReactComponent };